import apiConfigs from "../configs/api.configs";
import axios from 'axios'

export default {
    methods: {
        getMovie(id) {
            return fetch(`${apiConfigs.apiUrl}/${id}${apiConfigs.apiKey}`)
            .then(res => res.json())
        },
        getMovies(name) {
            return fetch(apiConfigs.apiUrlSearch+"search/movie"+apiConfigs.apiKey+"&query="+name)
            .then(res => res.json()).then(res => res.results)
        },
        getMovieCredit(id) {
            return fetch(`${apiConfigs.apiUrl}/${id}/credits${apiConfigs.apiKey}`)
                .then(res => res.json()).then(res => res.cast)
        },
        getMovieSimilar(id) {
            return fetch(`${apiConfigs.apiUrl}/${id}/similar${apiConfigs.apiKey}`)
                .then(res => res.json()).then(res => res.results)
        },
        getTvCredit(id) {
            return fetch(`${apiConfigs.apiUrlTv}/${id}/credits${apiConfigs.apiKey}`)
                .then(res => res.json()).then(res => res.cast)
        },
        getTv(id) {
            return fetch(`${apiConfigs.apiUrlTv}/${id}${apiConfigs.apiKey}`)
                .then(res => res.json())
        },
        getTvSimilar(id) {
            return fetch(`${apiConfigs.apiUrlTv}/${id}/similar${apiConfigs.apiKey}`)
                .then(res => res.json()).then(res => res.results)
        },
        getMoviesAll() {
            return fetch(apiConfigs.apiUrlSearch+"discover/movie"+apiConfigs.apiKey)
            .then(res => res.json()).then(res => res.results)
        },
        getMoviesLatest() {
            return fetch(apiConfigs.apiUrl+"/latest"+apiConfigs.apiKey)
            .then(res=>res.json()).then(res => res.results)
        },
        getMoviesTopRated() {
            return fetch(apiConfigs.apiUrl+"/top_rated"+apiConfigs.apiKey)
            .then(res=>res.json()).then(res => res.results)
        },
        getMoviesPopular() {
            return fetch(apiConfigs.apiUrl+"/popular"+apiConfigs.apiKey)
            .then(res=>res.json()).then(res => res.results)
        },
        getMoviesUpComing() {
            return fetch(apiConfigs.apiUrl+"/upcoming"+apiConfigs.apiKey)
            .then(res=>res.json()).then(res => res.results)
        },
        getTvTopRated() {
            return fetch(apiConfigs.apiUrlTv+"/top_rated"+apiConfigs.apiKey)
            .then(res=>res.json()).then(res => res.results)
        },
        getTvPopular() {
            return fetch(apiConfigs.apiUrlTv+"/popular"+apiConfigs.apiKey)
            .then(res=>res.json()).then(res => res.results)
        },
    }
}